// src/app/events/session/stream/StreamSessionParticipant.ts
import {SessionParticipant, SessionParticipantType} from '../model/SessionParticipant';
import {StreamVideoParticipant} from '@stream-io/video-client';

export type StreamSessionParticipantData = {
  sessionId: string;
  publishedTracks: number[];
};

export class StreamSessionParticipant extends SessionParticipant {

  constructor(
    public name: string,
    public userId: string | number,
    public isHost: boolean,
    public videoOn: boolean,
    public muted: boolean,
    public isCurrentUser: boolean,
    public teacher: boolean,
    public utishaUserId: number,
    public useSelfVideo: boolean,
    public activeSpeaker = false,
    public data: StreamSessionParticipantData,
    public options?: { [key: string]: string; },
  ) {
    super();
  }

  private static parseUtishaUserId(streamUserId: string): number {
    const number = streamUserId.split("-")[1];
    if (!number) {
      throw new Error('Invalid Stream.io userId');
    }
    return parseInt(number, 10); // Converts to number: 123
  }

  static fromParticipant(participant: StreamVideoParticipant, currentUserId: number): StreamSessionParticipant {
    const data = {
      sessionId: participant.sessionId,
      publishedTracks: participant.publishedTracks,
    };
    const utishaUserId = StreamSessionParticipant.parseUtishaUserId(participant.userId);
    return new StreamSessionParticipant(
      participant.name || participant.userId,
      participant.userId,
      false, // Adjust if you designate hosts in Stream.io
      !!participant.publishedTracks.includes(2), // 2 = Video
      !participant.publishedTracks.includes(1),  // 1 = Audio
      currentUserId === utishaUserId,
      false, // Adjust if you have a teacher role
      utishaUserId, // Assuming userId is utishaUserId
      true, // Stream.io uses HTML video elements,
      false,
      data,
      {}
    );
  }

  get type(): SessionParticipantType {
    if (this.isCurrentUser) {
      return SessionParticipantType.SELF;
    }
    if (this.isHost) {
      return SessionParticipantType.HOST;
    }
    return SessionParticipantType.PARTICIPANT;
  }
}
